import { render, staticRenderFns } from "./InventoryMoveModal.vue?vue&type=template&id=68e484f8&scoped=true"
import script from "./InventoryMoveModal.vue?vue&type=script&lang=js"
export * from "./InventoryMoveModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryMoveModal.vue?vue&type=style&index=0&id=68e484f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e484f8",
  null
  
)

export default component.exports